export default __webpack_public_path__ + "assets/traveler-with-a-suitcase.04748a1e.svg";